import { useState } from "react";
import { LevelOfProtectionType } from "../addLegalEntityDialog/AddLegalEntityDialog.types";
import { ILegalEntityThirdCountryDialog } from "./LegalEntityThirdCountryDialog";
import { LegalEntityThirdCountrySettingsViewModel } from "./LegalEntityThirdCountryDialog.types";
import { put } from "../../common/api/apiShared";
import { useLevelsOfProtectionForSelection } from "../useLevelsOfProtectionForSelection.ts";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { useTransferBasesQuery } from "@common/hooks/useSelectableItemQueries.ts";
import { EUToUSDataPrivacyFrameworkId } from "../../legalBasis/TransferBasis.Helper.ts";

export default function useLegalEntityThirdCountryDialogHooks(props: ILegalEntityThirdCountryDialog) {
    const getLevelsOfProtection = useLevelsOfProtectionForSelection();

    const [viewModel, setViewModel] = useState<LegalEntityThirdCountrySettingsViewModel>(props.thirdCountrySettings);
    let transferBasisQuery = useTransferBasesQuery();

    const saveMutation = useDotLegalMutation(updateThirdCountrySettingsApi, {
        onSuccess: (response: any) => {
            props.onSaved();
        },
    });

    const onSaveClick = async () => {
        await saveMutation.mutateAsync();
    };

    let transferBases = transferBasisQuery.data;

    const updateSaveModel = {
        onIsTIAUnnecessaryChange: (isTIAUnnecessary: boolean) => {
            const temp = { ...viewModel };
            temp.isTIAUnnecessary = isTIAUnnecessary;
            setViewModel(temp);
        },
        onIsTransferBasisUnnecessaryChange: (isTransferBasisUnnecessary: boolean) => {
            const temp = { ...viewModel };
            temp.isTransferBasisUnnecessary = isTransferBasisUnnecessary;
            setViewModel(temp);
        },
        onAddDataPrivacyFrameworkToSharingsChange: (addDataPrivacyFrameworkToSharings: boolean) => {
            const temp = { ...viewModel };
            temp.addTransferBasisToSharings = addDataPrivacyFrameworkToSharings;
            setViewModel(temp);
        },
        onLevelOfProtectionChange: (levelOfProtection: string) => {
            const temp = { ...viewModel };
            temp.levelOfProtection = LevelOfProtectionType[levelOfProtection as keyof typeof LevelOfProtectionType];
            temp.addTransferBasisToSharings = false;

            if (temp.levelOfProtection === LevelOfProtectionType.DataPrivacyFramework) {
                temp.transferBasisId = EUToUSDataPrivacyFrameworkId;
            }

            if (temp.levelOfProtection === LevelOfProtectionType.CPIEDA) {
                temp.transferBasisId = undefined;
            }

            setViewModel(temp);
        },
        onTransferBasisChange: (transferBasis: string | null) => {
            const temp = { ...viewModel };
            temp.transferBasisId = transferBasis ?? undefined;
            setViewModel(temp);
        },
    };

    function updateThirdCountrySettingsApi() {
        return put<{}>(`/LegalEntity/${props.legalEntityId}/thirdCountrySettings`, viewModel);
    }

    return {
        LevelOfProtections: getLevelsOfProtection(props.thirdCountrySettings.countryCode),
        viewModel,
        updateSaveModel,
        onSaveClick,
        isSaving: saveMutation.isLoading,
        transferBasisIsLoading: transferBasisQuery.isLoading,
        transferBases,
    };
}
